import {
  APP_SETTING_CHANGE_DEFAULT_LANGUAGE_BEGIN,
  APP_SETTING_CHANGE_DEFAULT_LANGUAGE_SUCCESS,
  APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE,
  APP_SETTING_CHANGE_DEFAULT_LANGUAGE_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { toast } from 'react-toastify';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';

export function changeDefaultLanguage(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_CHANGE_DEFAULT_LANGUAGE_BEGIN,
    });
    const { projectId, uuid } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}localization/setDefaultLanguage/${uuid}`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            dispatch({
              type: APP_SETTING_CHANGE_DEFAULT_LANGUAGE_SUCCESS,
              data: res.data,
              uuid: args.uuid,
            });
            toast.success('Deleted Successfully !', {});
            resolve(res);
          } else {
            dispatch({
              type: APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE,
              data: { error: 'Failed' },
            });
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissChangeDefaultLanguageError() {
  return {
    type: APP_SETTING_CHANGE_DEFAULT_LANGUAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CHANGE_DEFAULT_LANGUAGE_BEGIN:
      return {
        ...state,
        changeDefaultLanguagePending: true,
        changeDefaultLanguageError: null,
      };

    case APP_SETTING_CHANGE_DEFAULT_LANGUAGE_SUCCESS:
      return {
        ...state,
        changeDefaultLanguagePending: false,
        changeDefaultLanguageError: null,
        localization: action.data,
      };

    case APP_SETTING_CHANGE_DEFAULT_LANGUAGE_FAILURE:
      return {
        ...state,
        changeDefaultLanguagePending: false,
        changeDefaultLanguageError: action.data.error,
      };

    case APP_SETTING_CHANGE_DEFAULT_LANGUAGE_DISMISS_ERROR:
      return {
        ...state,
        changeDefaultLanguageError: null,
      };

    default:
      return state;
  }
}
